import { Box, Button, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useNavigate } from 'react-router-dom';

type CheckoutNoticeProps = {
  title: string;
  message: string;
};

/**
 * Full-page notice for a checkout that did not end in a confirmation
 * (missing PayPal approval, unavailable confirmation details, …). Styled to
 * match the confirmation page rather than bare error text.
 */
export default function CheckoutNotice({
  title,
  message,
}: CheckoutNoticeProps) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        minHeight: '50vh',
        px: 2,
        pt: 6,
      }}
    >
      <InfoOutlinedIcon color="action" sx={{ fontSize: 60 }} />
      <Typography variant="h4" gutterBottom sx={{ mt: 1 }}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ maxWidth: 560, mb: 3 }}
      >
        {message}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Button variant="contained" onClick={() => navigate('/cart/1')}>
          Go to cart
        </Button>
        <Button variant="outlined" onClick={() => navigate('/')}>
          Go to store
        </Button>
      </Box>
    </Box>
  );
}
